export function isElementInViewport(el: Element, tolerance: number = 0) {
  const rect = el.getBoundingClientRect()

  return (
    rect.top + tolerance >= 0 &&
    rect.left + tolerance >= 0 &&
    rect.bottom - tolerance <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right - tolerance <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

// Must stay in lockstep with the SCSS `mobile` mixin's $phone-max (assets/styles/core/_responsive.scss):
// same number, same fractional rounding. It was 479px, which disagreed with the stylesheet's 478px
// over a 1px band where the JS reported mobile and no mobile CSS applied.
const MOBILE_MEDIA_QUERY = 'only screen and (max-width: 478.98px)'

export function isMobile() {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches
}

export function subscribeToMobileChange(onChange: (isMobileViewport: boolean) => void): () => void {
  const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY)
  const handler = (event: MediaQueryListEvent) => onChange(event.matches)

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }

  mediaQuery.addListener(handler)
  return () => mediaQuery.removeListener(handler)
}

export function isViewportAtLeast(minWidthPx: number) {
  return window.matchMedia(`only screen and (min-width: ${minWidthPx}px)`).matches
}

export function subscribeToViewportWidthChange(minWidthPx: number, onChange: (matches: boolean) => void): () => void {
  const mediaQuery = window.matchMedia(`only screen and (min-width: ${minWidthPx}px)`)
  const handler = (event: MediaQueryListEvent) => onChange(event.matches)

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }

  mediaQuery.addListener(handler)
  return () => mediaQuery.removeListener(handler)
}

export function isSafari() {
  return navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') == -1
}

export function writeTextToClipboard(getText: Promise<string>) {
  if (isSafari()) {
    const clipboardItem = new ClipboardItem({ 'text/plain': getText })
    return navigator.clipboard.write([clipboardItem])
  } else {
    return getText.then(text => navigator.clipboard.writeText(text))
  }
}

export const scrollIfNecessary = (parentElement: HTMLElement, childElement: HTMLElement, down: boolean) => {
  const { scrollTop: parentScrollTop, clientHeight: parentHeight } = parentElement
  const { offsetTop: childTop, clientHeight: childHeight } = childElement

  if (down) {
    const lowerEntryBound = childTop + childHeight
    const lowerListBound = parentScrollTop + parentHeight
    parentElement.scrollBy({ top: Math.max(0, lowerEntryBound - lowerListBound) })
  } else if (childTop < parentScrollTop) {
    parentElement.scrollBy({ top: childTop - parentScrollTop })
  }
}
